import React from 'react';

// The heading every ResearchOS mode wears. ONE component rather than the same markup pasted
// into each page: Quorum and Chatter are read as siblings, and a title treatment copied twice
// stops being a pattern the first time one copy is edited.
//
// The attribution used to TRAIL the title on its own baseline — a serif word with a cramped
// uppercase suffix hung off the end of it. Two type scales and two cases fighting on one line
// read as an afterthought stuck to the title rather than a mark, and at 375px the suffix wrapped
// onto its own line anyway, just without any of the spacing that would have made that look
// deliberate. So it is an eyebrow now: its own line, above, led by a short accent rule. That
// buys the title a clear line to itself, which is what lets it carry real size and the tight
// tracking a serif display line wants.
//
// No strapline is offered for Quorum — the owner had those removed, and the crumb above plus
// the figures below already say what the page is.

export default function PageHeading({ title, note }) {
  return (
    <div className="mb-6">
      {/* The rule is what makes the eyebrow read as a mark rather than as a stray label:
          it anchors the wide letter-spacing to the left margin the title starts from. */}
      <div className="flex items-center gap-2">
        <span className="h-px w-5 shrink-0 bg-brand-gold/70" aria-hidden="true" />
        <span className="text-[10px] font-medium uppercase tracking-[0.28em] text-brand-gold">
          by ADCG
        </span>
      </div>
      {/* Bigger than the old text-2xl and tracked slightly in. A display serif set at its
          default spacing looks loose; negative tracking at this size is what makes it look
          set rather than typed. It fits 375px on one line at 30px — the step up to 38px is
          held back to sm so a long mode name can never push the page sideways on a phone. */}
      <h1 className="mt-2 font-serif text-[30px] leading-[1.05] tracking-[-0.015em] text-gray-900 sm:text-[38px] dark:text-gray-100">
        {title}
      </h1>
      {note ? (
        <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">{note}</p>
      ) : null}
    </div>
  );
}
